import React from 'react'
import PropTypes from 'prop-types'
import Loader from './Loader'
import { PageLoaderError } from '../errors'

const AsyncComponentLoader = ({ error, pastDelay, retry, timedOut }) => {
  if (error) {
    return <PageLoaderError retry={retry} />
  } else if (timedOut || pastDelay) {
    return <Loader>{timedOut ? __('Still loading') : __('Loading')}</Loader>
  } else {
    return null
  }
}

AsyncComponentLoader.propTypes = {
  error: PropTypes.object,
  pastDelay: PropTypes.bool,
  retry: PropTypes.func.isRequired,
  timedOut: PropTypes.bool,
}

export default AsyncComponentLoader
